import '@awesome.me/kit-97c1241a0b/icons/css/all.min.css';
import './index.css';

import Lui2GlobalTheme from '@app/lui2/Theme';
import {createRoot} from 'react-dom/client';

import App from './App';
import {initOutlookAddInRollbar} from './rollbar';

const renderApp = () => {
  const rootEl = document.getElementById('root');
  if (!rootEl) {
    throw new Error('Missing #root');
  }

  createRoot(rootEl).render(
    <>
      <Lui2GlobalTheme />
      <App />
    </>
  );
};

Office.onReady(() => {
  initOutlookAddInRollbar();
  renderApp();
});
